import { Button, styled, Typography, ButtonProps } from '@mui/material';
import { memo, MouseEventHandler } from 'react';

interface ICustomButtonprops extends ButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement> | undefined;
  title: string;
}

const StyledButton = styled(Button)(({ theme }) => ({
  minWidth: '100px',
  width: '100%',
  height: '40px',
  color: theme.palette.mind.custom.white,
  backgroundColor: theme.palette.mind.black.A10,
  border: '0px',
  borderRadius: '4px',
  '& .MuiTypography-root': {
    fontSize: 15,
    fontWeight: 400,
  },
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.mind.black.A10,
  },
  '&:disabled': {
    backgroundColor: theme.palette.mind.grey.disabled,
    color: theme.palette.mind.grey.A0,
  },
}));

function CustomButton(props: ICustomButtonprops) {
  const { onClick, title, ...others } = props;
  return (
    <StyledButton onClick={onClick} {...others}>
      <Typography>{title}</Typography>
    </StyledButton>
  );
}

export default memo(CustomButton);
